<template>
    <v-dialog v-model="display" persistent max-width="600">
        <v-card>
            <v-card-title class="text-h5">
                Eliminar
            </v-card-title>
            <v-card-text class="text-h6">{{ title }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text @click="$emit('closeFnc')">
                    Cancelar
                </v-btn>
                <v-btn color="primary" text @click="$emit('deleteFnc')">
                    Borrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        title: String,
        display: Boolean,
    },
    emits: ['deleteFnc', 'closeFnc'],
}
</script>